import Model from './model';

export default class Cell extends Model {
  text = '';
  updateText(_text) {
    this.text = _text;
    this.emitStateUpdate();
  }
}
